export const APP_CONFIG = {

  app: 'Back-Office',
  appName: 'Back-Office',
  user: 'Admin',
  email: 'drlantern@gotbootstrap.com',
  twitter: 'codexlantern',
  avatar: 'avatar-m.png',
  version: '4.0.0',
  bs4v: '4.3',
  logo: 'logo_pm.png',
  logoM: 'logo_pm.png',
  logoName: 'logo_name.png',
  // tslint:disable-next-line:max-line-length
  copyright: '2019 © SmartAdmin by&nbsp;<a href="https://www.gotbootstrap.com" class="text-primary fw-500" title="gotbootstrap.com" target="_blank">gotbootstrap.com</a>',
  // tslint:disable-next-line:max-line-length
  // copyrightInverse: '2019 © SmartAdmin by&nbsp;<a href="https://www.gotbootstrap.com" class="text-white opacity-40 fw-500" title="gotbootstrap.com" target="_blank">gotbootstrap.com</a>'
};
